/***********************************
  Locations Map Module
************************************/

Quad.LocationsMap = ( function() {

  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function initMap( test ) {

    var geocoder = new google.maps.Geocoder();

    // Map 1 - US

    if ( document.getElementById( 'locations-map-NorthAmerica' )) {

    mapNorthAmerica = new google.maps.Map( document.getElementById( 'locations-map-NorthAmerica' ), {
      center: { lat: 37.0902, lng: -95.7129 },
      zoom: 4,
      styles: [{
        featureType: 'administrative.locality',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'poi',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'road',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'transit',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'water',
        elementType: 'labels',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'water',
        stylers: [{
          color: '#d9dcde'
        }]
      }, {
        featureType: 'landscape.man_made',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'landscape.natural',
        stylers: [{
          color: '#b3b9bd'
        }]
      }],
      scrollwheel: !1,
      mapTypeControl: !1,
      panControl: !1,
      scaleControl: !1,
      streetViewControl: !1,
      overviewMapControl: !1,
      zoomControl: !0,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL
      }
    });

    for ( var i=0; i<locationsNorthAmerica.length; i++ ) {
      var coords = { lat: parseFloat( locationsNorthAmerica[ i ].lat ), lng: parseFloat( locationsNorthAmerica[ i ].long ) };
      makeMarker( mapNorthAmerica, coords, locationsNorthAmerica[ i ]);
      //geocoder.geocode({'address': locationsUnitedStates[i].address}, makeMarker(mapUnitedStates, locationsUnitedStates[i], locationsUnitedStates));
    }

  } // if US

    // Map 2 - Latin America

    if ( document.getElementById( 'locations-map-International' )) {

    mapInternational = new google.maps.Map( document.getElementById( 'locations-map-International' ), {
      center: { lat: 5.5005, lng: -20.7129 },
      zoom: 2,
      styles: [{
        featureType: 'administrative.locality',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'poi',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'road',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'transit',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'water',
        elementType: 'labels',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'water',
        stylers: [{
          color: '#d9dcde'
        }]
      }, {
        featureType: 'landscape.man_made',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'landscape.natural',
        stylers: [{
          color: '#b3b9bd'
        }]
      }],
      scrollwheel: !1,
      mapTypeControl: !1,
      panControl: !1,
      scaleControl: !1,
      streetViewControl: !1,
      overviewMapControl: !1,
      zoomControl: !0,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL
      }
    });

    for ( var i=0; i<locationsInternational.length; i++ ) {
      var coords = { lat: parseFloat( locationsInternational[ i ].lat ), lng: parseFloat( locationsInternational[ i ].long ) };
      makeMarker( mapInternational, coords, locationsInternational[ i ]);
      //geocoder.geocode({'address': locationsLatinAmerica[i].address}, makeMarker(mapLatinAmerica, locationsLatinAmerica[i], locationsLatinAmerica));
    }

    } // if Latin America

  }

  function highlight( name ) {
    //var $locationsList = $('.locations-list');
    var $locationsList = $( '.locations-list' ).find( '[data-name="' + name + '"]' );
	  var complete = false;
	  $( 'html,body' ).animate({ scrollTop: $locationsList.offset().top - 200 }, 200, 'linear', function() {
		  if ( !complete ) {
		    complete = true;
		    //var $link = $locationsList.find('[data-name="' + name + '"]')
        var $link = $locationsList;
        $link.removeAttr( 'style' );
		    setTimeout( function() {
			    $link.css({ animation: 'pulse 1s 2' });
		    }, 100 );
		  }
	  });
  }

  function makeMarker( map, coords, locations ) {
    //return( function(results){
    if ( coords ) {
		  var marker = new google.maps.Marker({
		    map: map,
		    //position: results[0].geometry.location,
        position: coords,
        icon: '/wp-content/themes/quad/assets/images/icons/icon-map-marker.svg'
		  });
		  marker.addListener( 'click', function() {
		    highlight( locations.name );
      });
		  if ( locations.length == 1 ) {
 console.log( 'work' );
			  //map.setCenter(results[0].geometry.location);
        map.setCenter( coords );
        map.setZoom( 6 );
      }
    }
  //});
  }


  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return {

    initMap: initMap

  };

})();
